"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireWildcard(require("react"));
var _reactTable = require("@tanstack/react-table");
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _table = require("./table.style");
var _index = require("./index");
var _Icon = _interopRequireDefault(require("../Icon"));
var _PaginationV = _interopRequireDefault(require("../PaginationV2"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

/* eslint-disable react-hooks/exhaustive-deps */

function useSkipper() {
  const shouldSkipRef = _react["default"].useRef(true);
  const shouldSkip = shouldSkipRef.current;
  // Wrap a function with this to skip a pagination reset temporarily
  const skip = _react["default"].useCallback(() => {
    shouldSkipRef.current = false;
  }, []);
  _react["default"].useEffect(() => {
    shouldSkipRef.current = true;
  });
  return [shouldSkip, skip];
}
const Table = _a => {
  var _b, _c;
  var {
      className = 'table',
      columnData,
      customExpanderClicked,
      customTableBody,
      currentPage,
      defaultData,
      disableSelectRows = false,
      fit = 'medium',
      gridLine = 'horizontal',
      state,
      maxHeight,
      maxWidth,
      reRenderTable = false,
      rowExpander,
      rowSelector = [],
      showPagination = false,
      stickyHeader = false,
      stickyFooter = false,
      tableWidth = 'full-width',
      toggleRowExpansion = false,
      totalPages,
      resetRowSelection,
      zebraStripes = false,
      manualSorting = false,
      onInputChange,
      onPageChange,
      onPageSizeOptionsChange,
      onRowClickCallback,
      onRowExpandedCallback,
      onRowSelection,
      onSorting,
      getRowStyle,
      getCellStyle
    } = _a,
    rest = __rest(_a, ["className", "columnData", "customExpanderClicked", "customTableBody", "currentPage", "defaultData", "disableSelectRows", "fit", "gridLine", "state", "maxHeight", "maxWidth", "reRenderTable", "rowExpander", "rowSelector", "showPagination", "stickyHeader", "stickyFooter", "tableWidth", "toggleRowExpansion", "totalPages", "resetRowSelection", "zebraStripes", "manualSorting", "onInputChange", "onPageChange", "onPageSizeOptionsChange", "onRowClickCallback", "onRowExpandedCallback", "onRowSelection", "onSorting", "getRowStyle", "getCellStyle"]);
  const [columns, setColumns] = (0, _react.useState)(() => (0, _toConsumableArray2["default"])(columnData));
  const [columnPinning, setColumnPinning] = (0, _react.useState)({});
  const [columnVisibility, setColumnVisibility] = (0, _react.useState)({});
  const [data, setData] = (0, _react.useState)(() => (0, _toConsumableArray2["default"])(defaultData));
  const [hasFooter, setHasFooter] = (0, _react.useState)(() => false);
  const [isRowSelectAdded, setIsRowSelectAdded] = (0, _react.useState)(false);
  const [isRowExpanderAdded, setIsRowExpanderAdded] = (0, _react.useState)(false);
  const [gridLines, setGridLine] = (0, _react.useState)(() => gridLine);
  const [autoResetPageIndex, skipAutoResetPageIndex] = useSkipper();
  const [expanded, setExpanded] = (0, _react.useState)({});
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [updateTable, setUpdateTable] = _react["default"].useState(false);
  const [rowSelection, setRowSelection] = _react["default"].useState({});
  const [sorting, setSorting] = (0, _react.useState)([]);
  const [{
    pageIndex,
    pageSize
  }, setPagination] = (0, _react.useState)({
    pageIndex: currentPage || 1,
    pageSize: totalPages || 10
  });
  const pagination = (0, _react.useMemo)(() => {
    if (showPagination) {
      setPagination({
        pageIndex: currentPage || 1,
        pageSize: totalPages || 10
      });
      return {
        pageIndex,
        pageSize
      };
    }
  }, [pageIndex, pageSize, currentPage, totalPages]);
  const table = (0, _reactTable.useReactTable)({
    autoResetPageIndex,
    data,
    columns,
    pageCount: totalPages || 10,
    manualPagination: true,
    enableSorting: true,
    enableColumnResizing: true,
    getSubRows: row => row.subRows,
    getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
    getExpandedRowModel: (0, _reactTable.getExpandedRowModel)(),
    getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
    onColumnPinningChange: setColumnPinning,
    onColumnVisibilityChange: setColumnVisibility,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onRowSelectionChange: setRowSelection,
    onExpandedChange: setExpanded,
    enableSubRowSelection: true,
    manualSorting: manualSorting,
    meta: {
      updateData: (rowIndex, columnId, value) => {
        // Skip page index reset until after next rerender
        skipAutoResetPageIndex();
        setData(old => old.map((row, index) => {
          if (index === rowIndex) {
            return (0, _extends2["default"])((0, _extends2["default"])({}, old[rowIndex]), {
              [columnId]: value
            });
          }
          return row;
        }));
      }
    },
    state: (0, _extends2["default"])({
      columnPinning,
      columnVisibility,
      pagination,
      rowSelection,
      sorting,
      expanded
    }, state)
  });
  (0, _react.useEffect)(() => {
    setColumns((0, _toConsumableArray2["default"])(columnData));
    setIsRowSelectAdded(false);
    setIsRowExpanderAdded(false);
    columnData === null || columnData === void 0 ? void 0 : columnData.forEach(col => {
      if (col.footer) {
        setHasFooter(true);
      }
    });
  }, [columnData]);
  (0, _react.useEffect)(() => {
    setData((0, _toConsumableArray2["default"])(defaultData));
    table.getRowModel().flatRows.forEach(row => {
      if (!row.getIsSelected() && row.original.selected) {
        row.toggleSelected();
      }
    });
    const leafs = new Set();
    table.getRowModel().flatRows.forEach(row => {
      if (!row.subRows.length && row.original.selected && row.parentId) {
        const parentRows = row.getParentRows();
        parentRows.forEach(item => {
          leafs.add(item.id);
        });
      }
    });
    for (const item of leafs) {
      table.getRowModel().flatRows.filter(row => row.id === item)[0].toggleExpanded();
    }
  }, [defaultData, customTableBody]);
  const IndeterminateCheckbox = _a => {
    var _b;
    var {
        indeterminate
      } = _a,
      rest = __rest(_a, ["indeterminate"]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const ref = _react["default"].useRef(null);
    (0, _react.useEffect)(() => {
      if (typeof indeterminate === 'boolean') {
        ref.current.indeterminate = !rest.checked && indeterminate;
      }
    }, [ref, indeterminate]);
    const value = rest.value && typeof rest.value === 'number' ? rest.value.toString() : typeof rest.value === 'object' ? rest.value : rest.value;
    return (0, _jsxRuntime.jsx)(_table.Components.CheckboxWrapper, {
      children: (0, _jsxRuntime.jsx)(_Checkbox["default"], {
        ref: ref,
        checked: rest.checked || false,
        disabled: disableSelectRows || rest.disabled,
        fit: fit,
        id: rest.id || "".concat(className, "-selectall-checkbox"),
        className: className + ' cursor-pointer selects',
        name: ((_b = rest.id) === null || _b === void 0 ? void 0 : _b.toString()) || 'selectAll',
        value: value,
        indeterminate: indeterminate,
        onChange: rest.onChange
      })
    });
  };
  const resetExpanded = activeRow => {
    if (toggleRowExpansion) {
      table.getRowModel().rows.forEach(rows => {
        if (rows && rows.getIsExpanded()) {
          table.resetExpanded();
        }
      });
      if (activeRow && activeRow.getIsExpanded()) {
        activeRow.toggleExpanded();
      }
    }
  };
  const onRowClick = (row, e) => __awaiter(void 0, void 0, void 0, function* () {
    if (onRowClickCallback) {
      onRowClickCallback(row.original, row.index, e);
    }
    yield resetExpanded(row);
    if (!rowExpander) {
      row.toggleExpanded();
    }
  });
  const renderSubComponent = _ref => {
    let {
      row
    } = _ref;
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: row.original.customElements
    });
  };
  (0, _react.useEffect)(() => {
    if (resetRowSelection) {
      table.resetRowSelection();
    }
  }, [resetRowSelection]);
  (0, _react.useEffect)(() => {
    if (typeof onRowSelection === 'function') {
      let selectedIndex = 0;
      const selectedRows = [];
      table.getSelectedRowModel().flatRows.forEach((x, key) => {
        selectedIndex = key - 1;
        if (!x.original.disabled) {
          selectedRows.push(x.original);
        }
      });
      if (selectedRows.length) {
        onRowSelection(selectedRows, selectedIndex);
      } else if (!table.getIsSomeRowsSelected()) {
        onRowSelection([], 0);
      }
    }
  }, [rowSelection]);
  (0, _react.useEffect)(() => {
    if (gridLine) {
      setGridLine(gridLine);
      table.getRowModel().rows.forEach(row => {
        if (row.original.config) {
          setGridLine('both');
        }
      });
    }
  }, [gridLine]);
  (0, _react.useEffect)(() => {
    setUpdateTable(reRenderTable);
    setColumns((0, _toConsumableArray2["default"])(columnData));
    // eslint-disable-next-line no-console
    console.log(updateTable);
  }, [reRenderTable]);
  (0, _react.useEffect)(() => {
    const {
      rows
    } = table.getRowModel();
    rows.forEach(row => {
      const allSubRowsSelected = row.subRows.length > 0 && row.subRows.every(_ref2 => {
        let {
          getIsSelected
        } = _ref2;
        return getIsSelected();
      });
      if (allSubRowsSelected) {
        row.toggleSelected(true);
      }
    });
  }, [rowSelection, table]);
  (0, _react.useEffect)(() => {
    if (rowSelector.length && !isRowSelectAdded) {
      const {
        id,
        columnPinning,
        meta,
        isVisible
      } = rowSelector[0];
      const selectorCoulumn = {
        id: id || 'select',
        size: 53,
        minSize: 53,
        columnPinning,
        meta,
        isVisible,
        className: 'selector',
        header: _ref3 => {
          let {
            table
          } = _ref3;
          return (0, _jsxRuntime.jsx)(IndeterminateCheckbox, (0, _extends2["default"])({}, {
            checked: table.getIsAllRowsSelected() || table.getIsSomeRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler()
          }));
        },
        cell: _ref4 => {
          let {
            row
          } = _ref4;
          return (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
            id: "selectBox"
          }, {
            children: (0, _jsxRuntime.jsx)(IndeterminateCheckbox, (0, _extends2["default"])({}, {
              id: row.id,
              checked: row.getIsSelected() && !row.original.disabled || row.getIsSomeSelected() && !row.original.disabled,
              disabled: row.original.disabled || !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler()
            }))
          }));
        }
      };
      setColumns(oldArray => [selectorCoulumn].concat((0, _toConsumableArray2["default"])(oldArray)));
      setIsRowSelectAdded(true);
    } else if (!rowSelector && columns[0].id === 'select') {
      if (columns[0].id === 'select') {
        setColumns((0, _toConsumableArray2["default"])(columns.slice(1)));
        setIsRowSelectAdded(false);
      }
    }
  }, [isRowSelectAdded, rowSelector]);
  (0, _react.useEffect)(() => {
    if (customExpanderClicked) {
      const row = table.getRow("".concat(customExpanderClicked));
      if (onRowExpandedCallback) {
        onRowExpandedCallback(row.original, row.index, customExpanderClicked);
      }
      resetExpanded();
      row.toggleExpanded();
    }
  }, [customExpanderClicked]);
  (0, _react.useEffect)(() => {
    if (rowExpander === 'default' && !isRowExpanderAdded) {
      const id = 'expand';
      const selectorCoulumn = {
        id,
        size: 53,
        minSize: 53,
        className: 'expander',
        enableSorting: false,
        columnPinning: 'left',
        meta: {
          stickyColumn: true
        },
        header: () => (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}),
        cell: _ref5 => {
          let {
            row
          } = _ref5;
          return (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
            id: "expand",
            className: "expander",
            onClick: e => __awaiter(void 0, void 0, void 0, function* () {
              if (onRowExpandedCallback) {
                onRowExpandedCallback(row.original, row.index, rowExpander, e);
              }
              yield resetExpanded(row);
              row.toggleExpanded();
            })
          }, {
            children: (0, _jsxRuntime.jsx)(_Icon["default"], {
              name: row.getIsExpanded() ? 'chevron-up' : 'chevron-down'
            })
          }));
        }
      };
      setColumns(oldArray => [selectorCoulumn].concat((0, _toConsumableArray2["default"])(oldArray)));
      setIsRowExpanderAdded(true);
    } else if (rowExpander && rowExpander.length && rowExpander !== 'custom' && !isRowExpanderAdded) {
      const {
        id,
        columnPinning,
        meta,
        isVisible
      } = rowExpander[0];
      const selectorCoulumn = {
        className: 'expander',
        id: id || 'expand',
        size: 53,
        minSize: 53,
        columnPinning,
        meta,
        isVisible,
        enableSorting: false,
        header: () => (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}),
        cell: _ref6 => {
          let {
            row
          } = _ref6;
          return (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
            id: "expand",
            onClick: e => __awaiter(void 0, void 0, void 0, function* () {
              if (onRowExpandedCallback) {
                onRowExpandedCallback(row.original, row.index, rowExpander[0], e);
              }
              yield resetExpanded(row);
              row.toggleExpanded();
            })
          }, {
            children: (0, _jsxRuntime.jsx)(_Icon["default"], {
              name: row.getIsExpanded() ? 'chevron-up' : 'chevron-down'
            })
          }));
        }
      };
      setColumns(oldArray => [selectorCoulumn].concat((0, _toConsumableArray2["default"])(oldArray)));
      setIsRowExpanderAdded(true);
    } else if (!rowExpander) {
      if (columns[0].id === 'expand') {
        setColumns((0, _toConsumableArray2["default"])(columns.slice(1)));
        setIsRowExpanderAdded(false);
      }
    }
  }, [isRowExpanderAdded, rowExpander]);
  (0, _react.useEffect)(() => {
    if (onSorting) {
      onSorting(sorting);
    }
  }, [onSorting, sorting]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_table.Components.Wrapper, (0, _extends2["default"])({
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      fit: fit,
      className: "".concat(className, "-container")
    }, {
      children: (0, _jsxRuntime.jsxs)(_table.Components.Table, (0, _extends2["default"])({
        className: "".concat(className, "-wrapper"),
        "$fit": fit,
        gridLine: gridLines,
        zebraStripes: zebraStripes,
        tableWidth: tableWidth
      }, {
        children: [(0, _jsxRuntime.jsx)(_index.Header, {
          className: className,
          fit: fit,
          headerData: table.getHeaderGroups(),
          stickyHeader: stickyHeader
        }), (0, _jsxRuntime.jsx)("tbody", {
          children: customTableBody ? (0, _jsxRuntime.jsx)("tr", (0, _extends2["default"])({
            className: "".concat(className, "-row")
          }, {
            children: (0, _jsxRuntime.jsx)("td", (0, _extends2["default"])({
              className: "".concat(className, "-cell"),
              colSpan: table.getAllLeafColumns().length
            }, {
              children: customTableBody
            }))
          })) : table.getRowModel().rows.map((row, index) => (0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
            children: [(0, _jsxRuntime.jsx)("tr", (0, _extends2["default"])({
              className: "".concat(className, "-row row-").concat(index),
              onClick: e => onRowClick(row, e),
              style: typeof getRowStyle === 'function' ? getRowStyle(row) : {}
            }, {
              children: (0, _jsxRuntime.jsx)(_index.TableCell, {
                row: row,
                table: table,
                className: className,
                cellData: row.getVisibleCells(),
                rowDepth: row.depth ? 2 : 0,
                fit: fit,
                onInputChange: onInputChange,
                getCellStyle: getCellStyle
              })
            }), row.id), row.getIsExpanded() && row.original.customElements && (0, _jsxRuntime.jsx)("tr", (0, _extends2["default"])({
              className: "".concat(className, "-custom-row row-").concat(index)
            }, {
              children: (0, _jsxRuntime.jsx)("td", (0, _extends2["default"])({
                colSpan: row.getVisibleCells().length
              }, {
                children: renderSubComponent({
                  row
                })
              }))
            }))]
          }, index))
        }), hasFooter && (0, _jsxRuntime.jsx)(_index.Footer, {
          footerData: table.getFooterGroups(),
          stickyFooter: stickyFooter
        })]
      }))
    })), showPagination && (0, _jsxRuntime.jsx)(_table.Components.PaginationWrapper, (0, _extends2["default"])({
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      fit: fit
    }, {
      children: (0, _jsxRuntime.jsx)(_PaginationV["default"], (0, _extends2["default"])({
        ariaLabel: "Navigate pages",
        currentPage: (_c = (_b = table.getState()) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.pageIndex,
        fit: "small",
        hidePageSizeOptions: false,
        nextLabel: "Next",
        onPageChange: value => onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(value),
        onPageSizeOptionsChange: value => onPageSizeOptionsChange === null || onPageSizeOptionsChange === void 0 ? void 0 : onPageSizeOptionsChange(value),
        previousLabel: "Previous",
        totalPages: table.getPageCount(),
        visiblePages: 5
      }, rest))
    }))]
  });
};
var _default = exports["default"] = Table;